<script lang="ts">
	//Svelte
	import { createEventDispatcher } from 'svelte';
	//Services
	import { format } from 'svelte-i18n';
	//Design System Components
	import { DropdownMenu, MenuItemList } from '@Shelly/shelly-design-system/index';
	//Helpers
	import {
		checkIsActionDisabled,
		dropdownSubmenuData,
		SHARED_HOME_ADD_ACTION_KEYS,
		type DrodpwonMenuSubmenuItemsTypes,
	} from 'src/helpers/main_menu';
	import { isActiveHomeShared } from 'src/helpers/houses/homes_helpers';
	import { homes } from 'src/stores/account/home';

	const dispatchActionEvent = createEventDispatcher<{
		'click-action': DrodpwonMenuSubmenuItemsTypes;
	}>();

	export let showAddActionsDropdown = false;

	let dropdownAddActions = [...dropdownSubmenuData];

	/**
	 * Shared homes only allow dashboard-related add actions; everything else is
	 * managed by the home owner, so it is filtered out of the menu.
	 */
	$: visibleDropdownAddActions = isActiveHomeShared($homes.list)
		? dropdownAddActions.filter((item) =>
				SHARED_HOME_ADD_ACTION_KEYS.includes(
					item.key as (typeof SHARED_HOME_ADD_ACTION_KEYS)[number],
				),
			)
		: dropdownAddActions;
	let submenuCloseOnHoverOut = false; // Set this variable to be able to close submenu on mouseleave and show it on mouseenter. Optionally we can make it to close on click out of component

	const clearSubmenuStates = () => {
		const closedSubmenusArr = dropdownAddActions.map((item) => {
			if (item?.hasOwnProperty('showDropdown')) {
				item.showDropdown = false;
			}

			item = {
				...item,
				active: false,
			};

			return item;
		});

		dropdownAddActions = [...closedSubmenusArr];
		submenuCloseOnHoverOut = false;
	};

	const onClickDropdownMenuItem = (item: DrodpwonMenuSubmenuItemsTypes) => {
		dispatchActionEvent('click-action', item);
	};
</script>

<DropdownMenu
	bind:show={showAddActionsDropdown}
	on:close={() => {
		clearSubmenuStates();
	}}
>
	<slot slot="trigger" name="trigger" />

	{#each visibleDropdownAddActions as dropdownAction, index}
		{@const isAddActionDisabled = checkIsActionDisabled(dropdownAction)}
		<MenuItemList
			on:mouseenter={() => {
				clearSubmenuStates();
			}}
			isGroupItem={dropdownAction.isGroupItem}
			title={$format(dropdownAction.title, {
				default: dropdownAction.defaultText,
			})}
			icon={dropdownAction.icon}
			on:click={() => {
				onClickDropdownMenuItem(dropdownAction);
			}}
			disabled={isAddActionDisabled}
		/>
	{/each}
</DropdownMenu>
